export const SECTION_TITLE_HEIGHT = 48;
export const TILE_HEIGHT = 88;
export const NO_REQUESTS_HEIGHT = 48;
export const GAP_HEIGHT = 8;
